export const invokeIfExists = <TReturnValue = unknown, TDefaultValue = TReturnValue, TArgs = never>(
  object: {
    [Key in string | number]: (...arg: TArgs[]) => TReturnValue;
  },
  key: string | number,
  defaultValue?: TDefaultValue,
  ...args: TArgs[]
): TReturnValue => {
  if (key in object) {
    return object[key](...args);
  }

  return defaultValue as unknown as TReturnValue;
};
